import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'


// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
    uid: 0, // From Auth
    displayName: 'Evolugy', // From Auth
    about: 'Evolugy team member.',
    photoURL: require('@/assets/images/evoUser.png'), // From Auth
    status: 'online',
    userRole: 'admin'
}

const evolugyUserDefaults = {
    active: true,
    address: "",
    address_2: "",
    city: "",
    country: "",
    created_at: "",
    deleted: false,
    deleted_at: null,
    dob: "",
    email: "",
    firebase_id: "",
    firebase_provider: "",
    firebase_uid: "",
    first_name: "",
    gender: "",
    id: 0,
    last_name: "",
    linkedin: "",
    notification_prefs: ["email", "sms"],
    phone: [""],
    role: "",
    specialty: "",
    state: "",
    sub_specialty: "",
    updated_at: "",
    zone: ""
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem('userInfo')) || {}
const EvolugyUserInfoSessionStorage = JSON.parse(sessionStorage.getItem('evolugyUser')) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
    const userInfo = {}

    // Update property in user
    Object.keys(userDefaults).forEach((key) => {
        // If property is defined in localStorage => Use that
        userInfo[key] = userInfoLocalStorage[key] ? userInfoLocalStorage[key] : userDefaults[key]
    })

    // Include properties from localStorage
    Object.keys(userInfoLocalStorage).forEach((key) => {
        if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null) userInfo[key] = userInfoLocalStorage[key]
    })

    return userInfo
}

const getEvolugyUserInfo = () => {
    const evolugyUserInfo = {}

    // Update property in user
    Object.keys(evolugyUserDefaults).forEach((key) => {
        // If property is defined in localStorage => Use that
        evolugyUserInfo[key] = EvolugyUserInfoSessionStorage[key] ? EvolugyUserInfoSessionStorage[key] : userDefaults[key]
    })

    // Include properties from localStorage
    Object.keys(EvolugyUserInfoSessionStorage).forEach((key) => {
        if (evolugyUserInfo[key] === undefined && EvolugyUserInfoSessionStorage[key] !== null) evolugyUserInfo[key] = EvolugyUserInfoSessionStorage[key]
    })

    return evolugyUserInfo
}

const getAuthToken = () => {
    console.log('getAuthToken');
    var authToken = '';

    const authUserKey = Object.keys(window.sessionStorage)
        .filter(item => item.startsWith('firebase:authUser'))[0];
    
    const authUser = JSON.parse(sessionStorage.getItem(authUserKey));
    console.log(authUser)
    if (authUser) {
        authToken = authUser.stsTokenManager.accessToken;
        console.log(authToken)
        return authToken;
    } else {
        authToken = '';
        return authToken;
    }

}


const getAuthTokenOld = () => {
    return sessionStorage.getItem('AT');
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
    const mq = function(query) {
        return window.matchMedia(query).matches
    }

    if ('ontouchstart' in window || window.DocumentTouch) {
        return true
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
    return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {

    AppActiveUser: getUserInfo(),
    EvolugyActiveUser: getEvolugyUserInfo(),
    AuthToken: getAuthToken(),
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    is_touch_device: is_touch_device(),
    mainLayoutType: themeConfig.mainLayoutType || 'vertical',
    navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: 'default',
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
    theme: themeConfig.theme || 'light',
    themePrimaryColor: colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    // ----------
    // EVENTS ---
    // ----------
    events: [],
    schedule: [],
    // ----------------
    // CONSULTATIONS --
    // ----------------
    consultations: [],
    paidConsultations: [],
    consultations_qty: null,
    pending_consultations_qty: null,
    clinicAvailabilityByDate: [],
    canceled_consultations_qty: null,
    confirmed_consultations_qty: null,
    activeConsultationInfo: null,
    publicConsultationInfo: null,
    // ----------
    // REVIEWS
    // ----------

    // ----------
    // CLINICS
    // ----------
    clinics: [],
    clinicsPublic: [],
    // ----------
    // USER MANAGEMENT
    // ----------
    users: [],
    patients: [],
    secretaries: [],
    active_patients_qty: null,
    currentPatient: null,
    publicPatient: null,
    publicDoctor: null,
    // ----------
    // MEDICATIONS
    // ----------
    medications: [],
    // ----------
    // PRESCRIPTIONS
    // ----------
    activePrescriptionInfo: null,
    prescriptionsList: [],
    // ----------
    // EXAMS
    // ----------
    activeExamInfo: null,
    examsList: [],
    // SECRETARY DOCTOR
    activeDoctorID: null,
    activeDoctor: null,
    notifsList: {},
}

export default state